import type { RouteRecordRaw } from 'vue-router'

import { AuthLayout as Layout } from '@/apps/adok/app/layout'

const UnsubscribePage = () =>
  import('@/apps/adok/pages/unsubscribe').then((m) => m.UnsubscribePage)

/**
 * The link in a mailing's footer. It sits on its own rather than in `routes/auth.ts`,
 * because it is not an auth screen: those carry `meta.auth`, which tells the guard to send
 * a signed-in visitor to the dashboard, and someone unsubscribing is usually signed in.
 *
 * The guard skips this route entirely — `app/router.ts` returns on `to.name ===
 * 'unsubscribe'` before it asks about a session — so the name is load-bearing. It is also
 * why the screen may not read the account: nothing has been loaded by the time it renders.
 */
const unsubscribeRoutes: RouteRecordRaw[] = [
  {
    path: '/unsubscribe/:token',
    component: Layout,
    children: [
      {
        path: '',
        name: 'unsubscribe',
        component: UnsubscribePage,
        meta: { hidden: true, title: 'Unsubscribe' }
      }
    ]
  }
]

export default unsubscribeRoutes
